import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFetch } from "@/hooks/useFetch";

export const PURPOSES = [["supply", "Supply"], ["job_work", "Job work"], ["other_than_supply", "Other than supply"]];
const NONE = "__default";

// Consigner warehouse, purpose of movement and special handling printed on the Delivery Challan.
export function ChallanFields({ value, onChange, testid = "challan" }) {
  const { data } = useFetch("/settings/warehouses?active=true");
  const rows = data || [];
  const def = rows.find((w) => w.is_default);
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <>
      <div className="col-span-2"><Label>Dispatch warehouse (consigner)</Label>
        <Select value={value.warehouse_id || NONE} onValueChange={(v) => set("warehouse_id", v === NONE ? null : v)}>
          <SelectTrigger data-testid={`${testid}-warehouse`}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value={NONE}>{def ? `Default — ${def.name} (${def.state_code})` : "Not set — add warehouses in Other masters"}</SelectItem>
            {rows.map((w) => <SelectItem key={w.id} value={w.id}>{w.name} · {w.state} · {w.gstin}</SelectItem>)}
          </SelectContent>
        </Select></div>
      <div><Label>Purpose of movement</Label>
        <Select value={value.purpose || "supply"} onValueChange={(v) => set("purpose", v)}>
          <SelectTrigger data-testid={`${testid}-purpose`}><SelectValue /></SelectTrigger>
          <SelectContent>{PURPOSES.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
        </Select></div>
      <div><Label>Special handling</Label><Input value={value.special_handling || ""} onChange={(e) => set("special_handling", e.target.value)} placeholder="e.g. Keep upright" data-testid={`${testid}-special-handling`} /></div>
    </>
  );
}
